import { BacklitContainer } from "./styles";

type BACKLIT_IMAGE_PROPS = {
  src: string;
  size: number | string;
};
const BacklitImage: React.FC<BACKLIT_IMAGE_PROPS> = ({ src, size }) => {
  return (
    <BacklitContainer {...{ size }}>
      <div className="light" />
      <img src={src} />
    </BacklitContainer>
  );
};

export { BacklitImage };
